<app-header
    class="header"
    [financialData]="financialData"
    [brand]="brand"
    [model]="model"
    [isPortraitDevice]="isPortraitDevice"
    (isOpenedFinancialCart)="isOpenedFinancialCart(isFinancialCartOpen)"
>
</app-header>

<app-stepper
    class="aside"
    *ngIf="!isFinancialCartOpen && !isPortraitDevice"
    [isFinancialCartOpen]="isFinancialCartOpen"
    [brand]="brand"
    [isPortraitDevice]="isPortraitDevice"
></app-stepper>
<!-- 
<div *ngIf="!isFinancialCartOpen" class="main">
     -->
<div *ngIf="!isFinancialCartOpen">
    <router-outlet *ngIf="!isFinancialCartOpen"></router-outlet>
</div>

<!-- 
<div *ngIf="!isFinancialCartOpen && isPortraitDevice" class="footer">
    <app-footer></app-footer>
</div>
    -->

<!-- 
<div *ngIf="!isFinancialCartOpen" class="chat-layer">
    <app-chat-layer></app-chat-layer>
</div>
 -->
